import React from 'react';
import DropdownBase from '../DropdownBase';
const base = function () {
  let type = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'items';
  return "".concat(process.env.REACT_APP_BASE_URL, "/").concat(type).concat(process.env.REACT_APP_URL_ENV, "/");
};
const name = 'Items';
const items = [{
  link: "".concat(base(), "items"),
  label: 'Items'
}, {
  submenu: true,
  menu: /*#__PURE__*/React.createElement(DropdownBase, {
    submenu: true,
    name: "Maintenance",
    items: [{
      link: "".concat(base(), "commodity_codes"),
      label: 'Commodity Codes'
    }, {
      link: "".concat(base(), "unit_of_measures"),
      label: 'Unit of Measures'
    }]
  })
}];
const Items = () => /*#__PURE__*/React.createElement(DropdownBase, {
  name: name,
  items: items
});
export default Items;